import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const UpdateUser = () => {
    const [user, setUser] = useState({});
    const { id } = useParams();

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/users/${id}`)
            .then((res) => res.json())
            .then((info) => setUser(info));
    }, [id]);

    const handleUser = (event) => {
        event.preventDefault();
        const userEmail = event.target.userEmail.value;
        const userRole = event.target.userRole.value;

        const userEdit = {
            userEmail,
            userRole
        };

        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/upadete-users/${id}`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(userEdit),
        })
            .then((res) => res.json())
            .then(() => {
                alert('User Is Updated');
            });
    };

    return (
        <>
        <HeaderBottom></HeaderBottom>
            <section id="services" className="services-area  d-flex align-items-center justify-content-center">
                <div className="container vh-100">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-8">
                            <h3 className="text-center mb-4">Update User Email</h3>
                            <form className="contact-form" onSubmit={handleUser}>
                                <div className="form-group mb-3">
                                    <input
                                        type="email"
                                        className="form-control form-control-lg shadow-lg p-3 mb-3 bg-white rounded "
                                        name="userEmail"
                                        defaultValue={user.userEmail || ''}
                                        placeholder="User Email"
                                        required
                                    />
                                </div>
                                <input
                                    type="hidden"
                                    name="userRole"
                                    defaultValue={user.userRole || 'Admin'}
                                />
                                <div className="text-center">
                                    <button type="submit" className="button-professional" data-animation="fadeInRight" data-delay=".8s">
                                        Update User Email
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default UpdateUser;
